<template>
	<Col v-if="notSupported" class="flex-centerize height-100">
		<h2 class="reg">Ply doesn't support Button dropdowns for this app yet.</h2>
	</Col>
	<Col v-else class="width-100 height-100">
		<Row class="flex-justify-space-between flex-align-center pt-7 pr-6">
			<Col>
				<Row class="flex-align-center">
					<AnemicButton @click="$router.back()" class="back-button" width="25" height="25" fab x-small>
						<AppIcon name="back" />
					</AnemicButton>
					<h1 class="title-text">Button Dropdowns</h1>
				</Row>
				<h3 class="description-text">Group multiple add-on buttons in a dropdown</h3>
			</Col>
			<AnemicButton v-if="canCreateNew" @click="$emit('show-wizard')" class="new-button">New button dropdown</AnemicButton>
		</Row>
		<ButtonsDropdownView v-on="$listeners" :page="page" :filterBy="filterBy" :idsToShow="idsToShow" />
	</Col>
</template>
<script>
import ButtonsDropdownView from '@/components/ButtonsDropdown/ButtonsDropdownView.vue';
export default {
	name: 'ButtonsDropdownTab',
	components: { ButtonsDropdownView },
	props: {
		idsToShow: { type: Array },
		filterBy: { type: Object },
		notSupported: { type: Boolean },
		page: { type: Number, default: 1 },
		canCreateNew: { type: Boolean, default: true },
	},
};
</script>

<style scoped lang="scss">
.back-button {
	margin-right: 6px;
	border-radius: 6px;
	border: 1px solid var(--grey-background);
}
.title-text {
	font-size: 20px;
	letter-spacing: 0px;
	text-align: left;
	color: var(--primary-font-color);
}
.description-text {
	font-size: 14px;
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
	font-weight: 300;
	text-align: left;
	letter-spacing: 0px;
}
.new-button {
	width: 170px !important;
	padding: 0px !important;
	height: 45px !important;
	border-radius: 8px !important;
	background-color: var(--fifth-color) !important;

	color: var(--bg-color);
	font-size: 14px !important;
	font-weight: normal !important;
}
</style>
